import * as React from 'react';
import Svg, { SvgProps, Path } from 'react-native-svg';

const InfoIcon16 = (props: SvgProps) => <Svg
  width={16}
  height={17}
  viewBox='0 0 16 17'
  fill='none'
  {...props}
>
  <Path
    d='M7.5 7.83333C7.63261 7.83333 7.75979 7.88601 7.85355 7.97978C7.94732 8.07355 8 8.20073 8 8.33333V10.8333C8 10.9659 8.05268 11.0931 8.14645 11.1869C8.24021 11.2807 8.36739 11.3333 8.5 11.3333M8 5.66667L7.5 5.47871M14 8.5C14 11.8137 11.3137 14.5 8 14.5C4.68629 14.5 2 11.8137 2 8.5C2 5.18629 4.68629 2.5 8 2.5C11.3137 2.5 14 5.18629 14 8.5Z'
    stroke='#548FC8'
    strokeWidth={1.5}
    strokeLinecap='round'
    strokeLinejoin='round'
  />
</Svg>;

export default InfoIcon16;
